/*
 * @Description:
 * @Autor: yd
 * @Date: 2020-07-02 11:21:57
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-18 11:43:39
 */
//定时任务
import http from '../httpConfig'

const table = "mrbase_sys_timed_task"
//验证cron语句是否正确 
export const verifyCron = (params = {}) => {
  return new Promise((resolve, reject) => {
    http.post('/api/job/checkCronExpressionIsValid/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


// 查询所有定时任务
export const getTimedTaskList = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/job/getTableQuartzAll/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
//获取定时任务详情
export const deatailTimedTask = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/job/getTableQuartzInfo/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

//新增定时任务接口
export const addTimedTask = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/job/addTimedTask/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

//修改定时任务内容
export const updateTimedTask = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/job/updateJob/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


//删除定时任务状态
export const deleteTimedTask = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/job/deleteQuartz/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


//修改定时任务状态
export const updateTimedTaskStatus = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/job/upStatusTask/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
//查询日志接口 
export const getLogList = (params = {}) => {
  return new Promise((resolve, reject) => {
    http.post('/api/job/getTableQuartzLogs/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

//执行定时任务接口
export const executeTimedTask = (params = {}) => {
  return new Promise((resolve, reject) => {
    http.post('/api/job/runTask/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}